<template>
    <h3 class="ui-section-title" :class="color !== 'muted' && `ui-section-title--${color}`">
        <slot />
    </h3>
</template>

<script setup lang="ts">
interface Props {
    color?: 'muted' | 'success' | 'warning' | 'danger';
}

withDefaults(defineProps<Props>(), {
    color: 'muted',
});
</script>
